import { BaseQueryFn } from '@reduxjs/toolkit/query/react'
import axios, { AxiosError, AxiosRequestConfig } from 'axios'

export interface IBaseQueryError {
  error: {
    status?: number
    data?: unknown | string
  }
}

const defaultHeaders = {
  'x-api-version': '1.0',
}

// Use with redux-toolkit-query (store)
const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: '' }
  ): BaseQueryFn<
    {
      url: string
      method: AxiosRequestConfig['method']
      data?: AxiosRequestConfig['data']
      params?: AxiosRequestConfig['params']
      headers?: AxiosRequestConfig['headers']
      responseType?: AxiosRequestConfig['responseType']
      overrideBaseUrl?: boolean
    },
    unknown,
    unknown
  > =>
  async ({
    url,
    method,
    data,
    params,
    headers = defaultHeaders,
    responseType,
    overrideBaseUrl,
  }) => {
    try {
      // Makes use of the axiosDefaults and can be overwritten
      const result = await axios({
        url: overrideBaseUrl ? url : baseUrl + url,
        method,
        data,
        params,
        headers,
        responseType,
      })
      return { data: result.data }
    } catch (axiosError) {
      const err = axiosError as AxiosError
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      } as IBaseQueryError
    }
  }

export default axiosBaseQuery
